import React from 'react';
import PropTypes from 'prop-types';
import { tokens } from '@companycam/slab';
import { get } from 'lodash';
import styled from 'styled-components';
import DOMPurify from 'dompurify';

const EntryWrapper = styled.div`
  display: flex;
  margin: ${tokens.size_spacing_s}px 0;
  overflow: hidden;
`;

const EntryImage = styled.img`
  width: 320px;
  height: 225px;
  object-fit: cover;
  border-radius: ${tokens.size_border_radius_s}px;
`;

const NoteContainer = styled.div`
  padding: ${tokens.size_spacing_m}px ${tokens.size_spacing_xl}px
    ${tokens.size_spacing_m}px ${tokens.size_spacing_l}px;
  flex: 1;
`;

const SectionEntry = ({ entry }) => {
  const thumbnail = get(entry, 'data.reportPhoto.assetPreviewThumbnail', '');
  const text = get(entry, 'data.text', '');

  return (
    <EntryWrapper>
      <EntryImage src={thumbnail} alt="" />
      <NoteContainer
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
      />
    </EntryWrapper>
  );
};

SectionEntry.propTypes = {
  entry: PropTypes.object,
};

export default SectionEntry;
